import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-004512ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "red-bar-container" }
const _hoisted_4 = { class: "text-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/icon_dots_menu.svg",
  class: "dots-menu"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "mobile-nav" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "mobile-red-bar-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/icon_plus.svg",
  class: "mobile-icon"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.store.loaded && !_ctx.store.showMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("nav", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.menu, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.id,
                to: '/' + item.id,
                class: "container"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: item.text,
                    class: "menu-item"
                  }, null, 8, _hoisted_2),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['red-bar', {'red-bar-visible': _ctx.$route.params.category === item.id}])
                    }, null, 2)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/about",
              class: _normalizeClass(['text', { 'hide-text': _ctx.$route.name === 'about'}])
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Мы делаем фильмы, ролики, аудио, графику, анимацию, но мы отчетливо понимаем, что… реклама — это прежде всего идея, поэтому… ")
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.store.loaded && _ctx.store.showMobile)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            class: "mobile-wrapper",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMobileMenuActive = true))
          }, _hoisted_6),
          _createElementVNode("div", {
            class: _normalizeClass(['mobile-menu', {'mobile-menu-active': _ctx.isMobileMenuActive}])
          }, [
            _createElementVNode("nav", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._ctx.store.menu, ...[{id: 'about', text: 'Кто мы?'}]], (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: item.id,
                  to: '/' + item.id,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMobileMenuActive = false)),
                  class: "container"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: item.text,
                      class: "mobile-menu-item"
                    }, null, 8, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['red-bar', {'red-bar-visible': (_ctx.$route.params.category === item.id) || _ctx.$route.name === item.id} ])
                      }, null, 2)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]),
            (_ctx.isMobileMenuActive)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMobileMenuActive = false)),
                  class: "dots-menu mobile-link"
                }, _hoisted_11))
              : _createCommentVNode("", true)
          ], 2)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}